<template>
    <div v-if="skillTreesIn.length" class="apprentice-simple-card user-profile-skills-card">
        <div class="component-title">
            <h5 class="title">{{$t('survey.skills')}}</h5>

            <b-form-select
                class="apprentice-primary-select skill-tree-select"
                v-model="selectedSkillTreeId"
                :options="skillTreesIn"
                text-field="name"
                value-field="id">
            </b-form-select>
        </div>

        <div class="row latest-modules-wrapper" v-if="selectedSkillTree">
            <div class="col-12 col-xl-8 col-md-12 module-graph">
                <design-2021-survey-results-index-chart-component :skill-tree-in="selectedSkillTree">
                </design-2021-survey-results-index-chart-component>

                <p style="padding-top: 10px;">{{$t('survey.the_results_indicated_here_are_based_on_the_last_completed_rubrics_click_further_by_skills_to_see_the_progress_over_time')}}</p>
            </div>
            <div class="col-12 col-xl-4 col-md-12 module">
                <design-2021-survey-results-index-bars-component
                    :skill-tree-in="selectedSkillTree"
                >
                </design-2021-survey-results-index-bars-component>
            </div>
        </div>

        <div class="not-found with-header empty-skill-graph-list"
             v-else-if="!selectedSkillTree && this.skillTreesIn.length === 0">
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{$t('survey.you_have_not_completed_a_skill_set_yet')}}</div>
        </div>

        <div class="not-found with-header empty-skill-graph-list" v-else>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{$t('survey.you_have_not_chosen_any_skills_yet')}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "design-2021-survey-results-index-component",
    props: {
        skillTreesIn: {
            type: Array,
            default() { return []}
        }
    },
    data() {
        return {
            // skillTrees:[],
            ids: [],
            dropdownText: this.$t('survey.select_skills'),
            selectedSkillTreeId: null,
        }
    },
    computed: {
        selectedSkillTree() {
            return this.skillTreesIn.find((skillTree) => skillTree.id === this.selectedSkillTreeId)
        }
    },
    mounted() {
        this.selectedSkillTreeId = this.skillTreesIn.length ? this.skillTreesIn[0].id : null;
    }
}
</script>

<style scoped lang="scss">
    .module-graph {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }

    .user-profile-skills-card {
        padding-bottom: map-get($grid-gutter-spacing, 'ten') * 3.7;

        .component-title {
            flex-wrap: wrap;

            .title {
                margin-bottom: map-get($grid-gutter-spacing, 'ten');
            }
        }

        .skill-tree-select {
            margin-bottom: 0;
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'sm')){
        .user-profile-skills-card {
            .component-title {
                flex-wrap: nowrap;

                .title {
                    margin-bottom: 0;
                }
            }

            .skill-tree-select {
                margin-left: auto;
                width: fit-content;
                max-width: 350px ;
            }
        }


    }
</style>
